import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {AppState} from '@Redux/store';
import {Dispatch} from "@Redux/type";
import {container} from "@Container";
import {TYPES} from "@Types";
import {ArmiesAction, ArmyListsAction, VersionsAction} from "@Redux/actions";
import SearchArmyListForm from "./SearchArmyListForm";
import {SearchArmyListParams} from "./validate";
import {ArmyListSearchPresenter} from "@Selectors/searchArmyList/make/ArmyListSearchPresenter";
import Repeater from "@Utils/Repeater";
import SearchArmyListComponent from "./SearchArmyListComponent";
import { myArmyListsPresenter } from '@Selectors/builder/myBuilder/show/myArmyListsPresenter';
import { ArmyListView } from '@Selectors/builder/myBuilder/show/view/ArmyListView';

const SearchMake: React.FC<SearchMakeProps> = ({
                                                 loadVersions,
                                                 loadArmies,
                                                 handleSubmit,
                                                 datas,
                                                 armyLists,
                                               }) => {
  useEffect(() => {
    loadVersions();
    loadArmies();
  }, []);
  return (
    <section className="mt-2 text-center">
      <div>
        {datas.isLoading && <div className="loader"/>}
        {!datas.isLoading &&
            <SearchArmyListForm versions={datas.versions} armies={datas.armies}
                                onSubmit={handleSubmit} canSubmit={datas.canSubmit}/>}
      </div>
      <div>
        <div className="content row justify-content-center">
          <Repeater data={armyLists} indexPrefix='army-list'>
            {
              (item: ArmyListView) => <SearchArmyListComponent armyList={item}/>
            }
          </Repeater>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state: AppState) => ({
  datas: ArmyListSearchPresenter(state),
  armyLists: myArmyListsPresenter(state, {})
});

const mapDispatchToProps = (dispatch: Dispatch) => {

  const armiesAction = container.get<ArmiesAction>(TYPES.Actions.ArmiesAction);
  const versionsAction = container.get<VersionsAction>(TYPES.Actions.VersionsAction);
  const armyListsAction = container.get<ArmyListsAction>(TYPES.Actions.ArmyListsAction);
  return {
    handleSubmit: (values: SearchArmyListParams) => {
      dispatch(armyListsAction.searchArmyLists(values));
    },
    loadVersions: () => dispatch(versionsAction.fetchData()),
    loadArmies: () => dispatch(armiesAction.fetchData()),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchMake);

type SearchMakeProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
